import { connect } from '@vfde-sails/core';
import { mountNonBookableCard, updateNonBookableCard } from '../../components/nonBookableCard';
import { AppId } from '../../enums/elementId';
import { State, mapStateToProps } from './selector';
import { getUpdateFlags } from './update';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';
import { NonBookableKeys } from '../../interface';

function container(_: State) {
    const nonBookableCard = mountNonBookableCard(AppId.NON_BOOKABLE_CARD);
    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const { disableBooking, customerType, publicFactName } = newState;

            const update = getUpdateFlags(newState, oldState);

            if (update.nonBookableCard) {
                if (customerType) {
                    updateNonBookableCard(nonBookableCard, customerType as NonBookableKeys);
                } else if (publicFactName) {
                    updateNonBookableCard(nonBookableCard, publicFactName as NonBookableKeys);
                }

                if (disableBooking) {
                    toggleElementVisibilityById(AppId.NON_BOOKABLE_CARD, true);
                } else {
                    toggleElementVisibilityById(AppId.NON_BOOKABLE_CARD, false);
                }
            }
        },
    };
}

export default connect(mapStateToProps)(container);
